module.exports = __webpack_public_path__ + "img/Association_VPA_1.c855aa4b.jpg";